<div class="color-bar"></div>

<div>    
    <app-bi-aspuio-lista
        [filtros]="filtros"
        (exibir)="selecionar($event)">    
    </app-bi-aspuio-lista>
</div>
